<section class="video-tutorial-section">
  <div class="container">

    <h2 class="video-title">
      {{ title | translate }}
    </h2>

    <div class="row align-items-start">

      <!-- Video Column -->
      <div class="col-12 col-lg-8 mb-4 mb-lg-0">
        <div class="video-wrapper">
          <div class="video-container">
            <video
              #videoPlayer
              controls
              [poster]="videoPoster"
              class="tutorial-video"
              (play)="onVideoPlay()"
              (pause)="onVideoPause()"
              (ended)="onVideoEnded()">
              <source [src]="videoPath" type="video/mp4">
              Your browser does not support the video tag.
            </video>

            <div class="play-button-overlay" [class.hidden]="isPlaying" (click)="playVideo()">
              <div class="play-button">▶</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Features Column -->
      <div class="col-12 col-lg-4">
        <div class="features-content">
          <h3 class="features-title">{{ 'videoTutorial.inThisVideo' | translate }}</h3>
          <ul class="features-list">
            <li *ngFor="let feature of features">
              <span class="bullet">•</span>
              <span>{{ feature | translate }}</span>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <!-- Button -->
  <div class="text-center mt-md-4 mt-1">
  <button class="gradient-button" (click)="onButtonClick()">
    {{ buttonText | translate }}
  </button>
</div>

  </div>
</section>